import React, { useEffect } from "react";


import "./index.scss";


interface SystemCommunicateElementComponentProps {
    communicateType: 'information' | 'success' | 'warning' | 'error';
    communicateText: string;
    communicateCloseCallback?: () => void;
}


export const SystemCommunicateElementComponent:React.FC<SystemCommunicateElementComponentProps> = ({
    communicateType = 'information', communicateText, communicateCloseCallback
}) => {

    const [communicateDisplayStatus, setCommunicateDisplayStatus] = React.useState(true);

    if (!communicateDisplayStatus || !communicateText) {
        return null;
    }

    const closeCommunicateTrigger = () => {
        setCommunicateDisplayStatus(false);
        if (communicateCloseCallback) {
            communicateCloseCallback();
        }
    }

    return (
        <div className={'page-blackout-element'}>
            <div className={`system-communicate-element-component ${communicateType}-system-communicate-element`}>
                <span className={'system-communicate-element-component__close-communicate'} onClick={closeCommunicateTrigger}>x</span>
                <span>{communicateText}</span>
            </div>
        </div>
    );

};


export default SystemCommunicateElementComponent;
